<template>
  <div class="card questions">
    <div class="card-header">
      <h3 class="card-title">{{$t('administrator.details.title.administrator')}}: <span class="text-bold" v-if="administratorDetails">{{ administratorDetails.email }}</span></h3>
      <div class="d-flex justify-content-end">
        <router-link :to="{ name: 'administrator' }">
          <b-button size="sm" variant="outline-primary">{{$t('administrator.details.btn.back_to_list')}}</b-button>
        </router-link>
      </div>
    </div>
    <div class="card-body">
      <b-card no-body>
        <b-tabs card>
          <template #tabs-end>
            <b-nav-item :active="$route.name === 'administrator-profile'"
                         @click="goToPage('administrator-profile')">
              {{$t('administrator.details.tab.profile')}}
<!--              <b-icon v-if="administratorFormInvalid" icon="exclamation-circle-fill" variant="danger" font-scale="1"></b-icon>-->
            </b-nav-item>
            <b-nav-item
                v-if="administratorDetails"
                :active="$route.name === 'administrator-security'"
                @click="goToPage('administrator-security')">
              {{$t('administrator.details.tab.security')}}</b-nav-item>
          </template>
          <template #default>
            <div class="tab-pane active card-body">
              <router-view></router-view>
            </div>
          </template>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import alertify from "alertifyjs";

export default {
  props: ['apiKey'],
  data() {
    return {
      activeTab: '',
      playerId: null
    };
  },
  computed: mapState({
    administratorDetails: state => state.administrator.administratorDetails,
    administratorDataForm: state => state.administrator.administratorDataForm
  }),
  beforeCreate() {
    const isCreatedRoute = this.$route.params.type;

    if(isCreatedRoute) {
      this.$store.commit('administrator/setIsCreateAdministratorPage', true);
      this.$store.commit('administrator/setAdministratorDataIsLoading', false);
      this.$store.commit('administrator/setFormEmail', '');
      this.$store.commit('administrator/setFormPhoneNumber', '');
      this.$store.commit('administrator/setFormClock24Hours', false);
      this.$store.commit('administrator/setFormLocale', '');
      this.$store.commit('administrator/setFormTenantId', '');
      this.$store.commit('administrator/setFormTimezone', '');
      this.$store.commit('administrator/setFormDateFormat', '');
      this.$store.commit('administrator/setFormPlainPassword', '');
      this.$store.commit('administrator/setFormRepeatedPassword', '');
      this.$store.commit('administrator/setFormEnabled', false);
      this.$store.commit('administrator/setFormLocked', false);
      this.$store.commit('administrator/setAdministrator', false);
      this.$store.commit('administrator/setSelectedRoles', []);
      this.$store.commit('administrator/setSelectedGroups', []);
    }
  },
  created() {
    this.$store.dispatch('administrator/getRoles');
    this.$store.dispatch('administrator/getGroups');

    this.playerId = this.$route.params.id;

    if(this.playerId) {
      this.getAdministratorDetails(this.playerId);
    }
  },
  beforeDestroy() {
    this.$store.commit('administrator/resetAdministratorDataForm');
    this.$store.commit('administrator/resetAdministratorPasswordForm');
    this.$store.commit('administrator/setIsCreateAdministratorPage', false);
  },
  methods: {
    saveAdministratorData() {
      return new Promise((resolve, reject) => {
        const data = this.administratorDataForm;

        this.$store.dispatch('administrator/setAdministratorData', data).then(resp => {
          resolve(resp);
        })
        .catch(error => {
          alertify.error(error.response.data.title);
          reject();
        });
      })
    },
    goToPage(name) {
      this.$router.push({name: name, params: {id: this.playerId}});
    },
    getAdministratorDetails(id) {
      this.$store.dispatch('administrator/getAdministratorDetails', id);
    },
  }
}
</script>

